import axios from 'axios';

const instance = axios.create({
  timeout: 30000,
});

const axiosHook = async (method, url, params, config = {}) => {
  let response = null;
  try {
    switch (method) {
      case 'post':
        response = await instance.post(
          url,
          params,
          config,
        );
        break;
      case 'get':
        response = await instance.get(
          url,
          {
            params,
          },
          config,
        );
        break;
      default:
        break;
    }
  } catch (error) {
    if (!response) {
      console.error(error);
      return;
    }
  }

  return response;
};

export default axiosHook;
